import { render } from "./NewOrderFooter.vue?vue&type=template&id=b2dbf72e&scoped=true&ts=true"
import script from "./NewOrderFooter.vue?vue&type=script&lang=ts"
export * from "./NewOrderFooter.vue?vue&type=script&lang=ts"

import "./NewOrderFooter.vue?vue&type=style&index=0&id=b2dbf72e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.27_typescript@5.9.3__webpack@5.105.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2dbf72e"]])

export default __exports__